import * as React from "react";

const Footer = () => (
  <footer className="site-footer">
    <span>© {new Date().getFullYear()} Ruofan Wei.</span>
    <span className="site-footer__links">
      <a href="https://github.com/ruofanwei" target="_blank" rel="noreferrer">
        GitHub
      </a>
      <a
        href="https://www.linkedin.com/in/ruofan-wei-a65922132/"
        target="_blank"
        rel="noreferrer"
      >
        LinkedIn
      </a>
      <a href="mailto:px732amgo81sp8@gmail.com">Email</a>
    </span>
  </footer>
);

export default Footer;
